/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressRelease,
    PressReleaseFromJSON,
    PressReleaseFromJSONTyped,
    PressReleaseToJSON,
} from './PressRelease';

/**
 * メディアユーザーにおすすめの企業情報（新UI用）
 * @export
 * @interface RecommendCompany
 */
export interface RecommendCompany {
    /**
     * 企業ID
     * @type {number}
     * @memberof RecommendCompany
     */
    companyId: number;
    /**
     * 企業名
     * @type {string}
     * @memberof RecommendCompany
     */
    companyName: string;
    /**
     * 企業名（原文）
     * @type {string}
     * @memberof RecommendCompany
     */
    companyNameOrigin: string;
    /**
     * ロゴ画像URL
     * @type {string}
     * @memberof RecommendCompany
     */
    logoImageUrl: string | null;
    /**
     * 新着プレスリリース一覧
     * @type {Array<PressRelease>}
     * @memberof RecommendCompany
     */
    newarrivalsReleaseList: Array<PressRelease>;
}

export function RecommendCompanyFromJSON(json: any): RecommendCompany {
    return RecommendCompanyFromJSONTyped(json, false);
}

export function RecommendCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'companyNameOrigin': json['company_name_origin'],
        'logoImageUrl': json['logo_image_url'],
        'newarrivalsReleaseList': ((json['newarrivals_release_list'] as Array<any>).map(PressReleaseFromJSON)),
    };
}

export function RecommendCompanyToJSON(value?: RecommendCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'company_name': value.companyName,
        'company_name_origin': value.companyNameOrigin,
        'logo_image_url': value.logoImageUrl,
        'newarrivals_release_list': ((value.newarrivalsReleaseList as Array<any>).map(PressReleaseToJSON)),
    };
}

